import React from 'react';
import { FiftyFiftyTextStyles as S } from './FiftyFiftyText.styles';
const FiftyFiftyText = ({ contentLeft, contentRight, align, }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Inner, { "data-text-align": align ?? 'left' },
            React.createElement(S.ContentWrapper, null, contentLeft && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: contentLeft } })),
            React.createElement(S.ContentWrapper, null, contentRight && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: contentRight } })))));
};
export default FiftyFiftyText;
